import { FC, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../../store/hooks";
import { setWorkflowCreationDrawerOpen } from "../../../../../../store/schedules/schedulesSlice";
import { resourceTypeSearchParam } from "../../../utils/constants/searchParams";
import { useCreateWorkflow } from "../../../utils/hooks/useCreateWorkflow.hook";
import { liveUsageMgmtAccountsWorkflowDataSelector } from "../../../../../../store/live-usage-mgmt/selectors/accounts-data/liveUsageMgmtAccountsWorkflowDataSelector";
import { ScheduleActionType } from "../../../../../../services/cloudchipr.api";
import { LiveResourcesCreateWorkflow } from "../../common/LiveResourcesCreateWorkflow";
import { liveUsageMgmtAccountAllReadOnlySelector } from "../../../../../../store/live-usage-mgmt/selectors/store-selectors/liveUsageMgmtAccountAllReadOnlySelector";

export const LiveResourcesCreateWorkflowActionButton: FC = () => {
  const dispatch = useAppDispatch();

  const [searchParams] = useSearchParams();
  const resourceType = searchParams.get(resourceTypeSearchParam);
  const allReadOnly = useAppSelector(liveUsageMgmtAccountAllReadOnlySelector);

  const accountsWorkflowData = useAppSelector((state) =>
    liveUsageMgmtAccountsWorkflowDataSelector(state, resourceType),
  );

  const createWorkflow = useCreateWorkflow(accountsWorkflowData);

  const itemClickHandler = useCallback(
    (action: ScheduleActionType) => {
      createWorkflow(action);
      dispatch(setWorkflowCreationDrawerOpen(true));
    },
    [dispatch, createWorkflow],
  );

  return (
    <LiveResourcesCreateWorkflow
      onItemClick={itemClickHandler}
      disableActionItems={allReadOnly}
      actionItemsTooltipTitle={
        allReadOnly ? disabledActionItemsTooltipTitle : ""
      }
    />
  );
};

const disabledActionItemsTooltipTitle =
  "All selected accounts are Read Only. You can only create Notify Only workflow for them";
